import React, { useRef, ChangeEvent, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
//components
import Text from 'components/Text';
import { Button } from 'components/Button';
//assets
import arrowDown from 'img/arrow-down-grey.svg';
import searchIcon from 'img/search-icon.svg';
import filterIcon from 'img/filter-multiselect.svg';
//utils
import { IsNullOrEmpty } from 'utils/StringNullOrEmpty';
import { useOutsideClick } from 'hooks/useOutsideClick';
import { generateRandomId } from 'utils/GenerateRandomId';
//interface
import { IUser } from 'models/User';
import { MultiCategoryHandler } from './interface';
//styles
import "./styles.scss";

const QuoteMultiSelect: React.FC<MultiCategoryHandler> = ({
  updateSelectedOptions,
  arraySelectedOptions,
  optionsToSelect,
  title,
  placeholder,
  show,
  setShow,
  className,
  style,
  openOptions,
  subsidiaryFilter
}) => {

  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef, setShow);
  const user = useSelector((state: { user: IUser; }) => state.user);
  const bcgOnly = process.env.REACT_APP_BCG_ONLY === 'true';

  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    if (!show) setSearchText('');
  }, [show]);

  const filteredOptions = searchText
    ? optionsToSelect.filter(opt =>
        opt.label.toLowerCase().includes(searchText.toLowerCase())
      )
    : optionsToSelect;

  const handleSelectedCategories = (option: ChangeEvent<HTMLInputElement>) => {
    if (option.target.checked) {
      updateSelectedOptions([...arraySelectedOptions, option.target.value]);
    } else {
      updateSelectedOptions(arraySelectedOptions.filter((cat) => cat !== option.target.value));
    }
  };

  const selectButton = (openOptions: boolean) => {
    return (
      <Button
        className="color-mediumGray bg-white"
        onClick={() => setShow(!show)}
        disabled={openOptions}
      >
        {placeholder}
      </Button>
    );
  };

  const imgClick = () => {
    const showEnable = bcgOnly || (title === "BU" ? IsNullOrEmpty(user?.buBCG) : true);

    if (showEnable) {
      if ((optionsToSelect.length > 0) || (optionsToSelect.length === 0 && subsidiaryFilter && subsidiaryFilter?.length > 0)) {
        setShow(!show);
      } else {
        setShow(false);
      }
    }
  };

  const colorCategories = (category: string) => `d-flex ${category === "100" ?
    "medicationCategory" : category === "2200" ? "nutritionsCategory" : "materialsCategory"}`;

  return (
    <>
      <Text size={12} className="select-text color-white mb-1">
        {title}
      </Text>
      <div ref={wrapperRef} className={`multiSelect-wrapper-ccare d-flex align-center selectorArea ${className}`} style={style}>
        {openOptions === false ? selectButton(true) : selectButton(false)}

        <a
          title='arrowSelect'
          className={`arrow-down ${show && 'arrow-down-inverse'}`}
          onClick={imgClick}>
          <img src={arrowDown} alt="" className={`${((optionsToSelect.length === 0 && !subsidiaryFilter) || !IsNullOrEmpty(user?.representative)) && 'disabled'}`} />
        </a>

        <ul
          className={
            show
              ? 'multiSelect-list multiSelect-list-ccare bg-white overflow-y-auto widthOptions'
              : 'multiSelect-list bg-white shadow-1 d-none'
          }
        >
          {show && (
            <li className="multiselect-header-item" onClick={(e) => e.stopPropagation()}>
              <button
                className="multiselect-clear-btn"
                onClick={() => updateSelectedOptions([])}
              >
                <img src={filterIcon} alt="" className="multiselect-clear-icon" />
                <span>Limpar filtros</span>
              </button>
              <div className="multiselect-search-wrapper">
                <input
                  type="text"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  placeholder="Pesquisar"
                  className="multiselect-search-input"
                  autoFocus
                />
                <img src={searchIcon} alt="" className="multiselect-search-icon" />
              </div>
            </li>
          )}
          {filteredOptions.length > 0 ? filteredOptions.map((opt) => (
            <li className={colorCategories(opt.value)} key={generateRandomId("MultiSelect")}>
              <div style={{ width: '0.8rem !important' }}>
                <input
                  checked={!!arraySelectedOptions.includes(opt.value)}
                  onChange={(e) => handleSelectedCategories(e)}
                  type="checkbox"
                  value={opt.value}
                  name={`cat-${opt.value}`}
                  id={`cat-${opt.value}`}
                />
              </div>
              <label style={{ paddingLeft: '0.6rem' }} htmlFor={`cat-${opt.value}`}>{opt.label}</label>
            </li>
          )) :
            <div className='withoutSeller'>
              <span className='multiSelectSpan'>
                {searchText ? 'Nenhum resultado encontrado' : (title === "Representante" && "Nenhum Representante")}
              </span>
            </div>}
        </ul>
      </div>
    </>
  );
};

export default QuoteMultiSelect;
